import { render, staticRenderFns } from "./BranchSectionInfo.vue?vue&type=template&id=696f4838"
import script from "./BranchSectionInfo.vue?vue&type=script&lang=ts"
export * from "./BranchSectionInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports